import classNames from 'classnames';
import { MouseEvent, useCallback, useState } from 'react';

import { useAppDispatch } from '~hooks/useRedux';
import { updateToggle } from '~redux/Actions/DisplayActions';

import * as btnStyles from './ButtonWithIcon.module.css';

type Props = {
    ['data-planname']?: string;
    ['data-wa-link']?: string;
    btntext?: string;
    icon?: string;
    isflipped?: boolean;
    class?: string;
    classes?: string;
    bgcolor?: string;
    disabled?: boolean;
    onClick?: (evt: MouseEvent<HTMLButtonElement>) => void;
    datawalink?: string | null;
};

const ButtonWithIcon = ({
    btntext,
    children,
    icon,
    isflipped,
    classes = '',
    bgcolor = '',
    datawalink = null,
    ...rest
}: React.PropsWithChildren<Props>) => {
    delete rest.class;
    const cssClasses = classNames((btnStyles as { [key: string]: string }).btn, classes);
    const [active, setActive] = useState(false);
    const dispatch = useAppDispatch();

    const handleClick = useCallback(
        (evt: MouseEvent<HTMLButtonElement>) => {
            if (rest.onClick) {
                rest.onClick(evt);
            } else {
                setActive((prevState) => {
                    dispatch(updateToggle(!prevState));

                    return !prevState;
                });
            }
        },
        [dispatch, rest.onClick]
    );

    // if datawalink (from CRM) is present override the data-wa-link parameter provided
    if (datawalink) rest['data-wa-link'] = datawalink;

    return (
        <button
            type="button"
            className={`${cssClasses} ${bgcolor} flex gap-x-2 items-center justify-center m-0 px-0 py-2 text-base ${isflipped ? 'flex-row-reverse' : ''}`}
            data-active={active}
            data-qa={datawalink}
            onClick={handleClick}
            {...rest}
        >
            <img
                className="duration-500 ease-in-out transition-transform"
                src={icon}
                alt="icon"
                aria-hidden="true"
                data-active={active}
            />
            <span>{active ? btntext?.replace('View', 'Hide') : btntext || children}</span>
        </button>
    );
};

export default ButtonWithIcon;
